/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Factories')
      .factory('ReportTeleSaqueB2BTransactionService', ReportTeleSaqueB2BTransactionService)

      ReportTeleSaqueB2BTransactionService.$inject = ['$resource']

  function ReportTeleSaqueB2BTransactionService($resource) {
      return $resource('', {}, {
          paged: {
              url: apiUrl + '/reports/telesaqueb2b-transactions-search',
              method: 'GET',
              params: {},
              isArray: false
          }
      })
  }
  // eslint-disable-next-line semi
})();
